<template>
  <div>
    <searchComponent v-show="isSearch" @on-search="handleSearch"/>
    <resultComponent v-show="!isSearch" ref="resultComponentRef" @on-prev="isSearch = true" @on-load-resource="handleLoadResource"/>
  </div>
</template>

<script>
import searchComponent from './LeftSearch.vue'
import resultComponent from './LeftResult.vue'

export default {
  components: {
    searchComponent, resultComponent
  },
  data () {
    return {
      isSearch: true
    }
  },
  methods: {
    handleSearch (params) {
      this.isSearch = false
      this.$refs.resultComponentRef.initPageData(params)
    },
    handleLoadResource (selectImg) {
      this.$emit('on-load-resource', selectImg)
    }
  }
}
</script>
